import React from "react";
import Icon from "../Icon";

export default (props) => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path
      d="M15 2a3 3 0 012.764 4.168l-.055.122C21.254 8.07 25 10.914 25 20c0 1.333.667 2.667 2 4H3c1.333-1.333 2-2.667 2-4 0-9.086 3.746-11.93 7.291-13.71l-.055-.122A3 3 0 0115 2zm5 22v1c0 2.5-2.239 5-5 5s-5-2.5-5-5v-1"
      fill="none"
    />
  </Icon>
);
